import type { ButtonHTMLAttributes, HTMLAttributes } from 'react';
import type { FamilyDevice, LocationPoint } from './types';
import { accuracy, landmark, primary, secondary, initials } from './locationDisplay';
import { locationFreshness } from './status';

export function PrimaryButton(props: ButtonHTMLAttributes<HTMLButtonElement>) { return <button {...props} className={`fdn-btn fdn-btn-primary ${props.className || ''}`} />; }
export function SecondaryButton(props: ButtonHTMLAttributes<HTMLButtonElement>) { return <button {...props} className={`fdn-btn fdn-btn-secondary ${props.className || ''}`} />; }

export function StatusPill({ point, label }: { point?: LocationPoint | null; label?: string }) {
  const status = point ? locationFreshness(point) : null;
  const text = label || status?.label || 'OFFLINE';
  const tone = status?.tone || 'offline';
  return <span className={`fig-status ${tone}`}><span className="fig-status-dot" />{text}</span>;
}

export function LocationCard({ point, distance }: { point?: LocationPoint | null; distance?: string }) {
  return <div className="resolved-location">
    <strong>{primary(point)}</strong>
    {secondary(point) && <span>{secondary(point)}</span>}
    {landmark(point) && <span>{landmark(point)}</span>}
    {distance && <b>{distance}</b>}
  </div>;
}

export function MemberCard({ device, now, onClick }: { device: FamilyDevice; now: number; onClick?: () => void }) {
  const status = locationFreshness(device.location, now);
  return <button className="fig-member-card" onClick={onClick}>
    <span className="fig-avatar">{initials(device.owner)}</span>
    <span className="fig-member-copy"><strong>{device.owner}</strong><span>{primary(device.location)}</span><small>{landmark(device.location) || status.age}</small></span>
    <span className={`fig-status ${status.tone}`}><span className="fig-status-dot" />{status.label}</span>
  </button>;
}

export function TechnicalDetails({ point }: { point?: LocationPoint | null }) {
  if (!point) return null;
  return <details className="technical-details"><summary>Technical details</summary><dl>
    <dt>Coordinates</dt><dd>{point.latitude.toFixed(6)}, {point.longitude.toFixed(6)}</dd>
    <dt>Accuracy</dt><dd>{accuracy(point)}</dd>
    <dt>Source</dt><dd>{point.source || 'device'}</dd>
    <dt>Recorded</dt><dd>{new Date(point.recordedAt).toLocaleString()}</dd>
    {point.resolutionQuality && <><dt>Resolution</dt><dd>{point.resolutionQuality.replaceAll('_', ' ')}</dd></>}
  </dl></details>;
}

export function Sheet({ children, className = '', ...props }: HTMLAttributes<HTMLElement>) { return <section {...props} className={`fig-sheet ${className}`}><div className="sheet-handle" />{children}</section>; }
